<template>
  <slot />
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'TabPanelItem',
    props: {
      value: {
        type: [String, Number],
        required: false,
        default: 1,
      },
      index: {
        type: [String, Number],
        required: false,
        default: 1,
      },
    },
  });
</script>
